// extracted by mini-css-extract-plugin
module.exports = {"base":"matchedTerm_base__2s_1n","active":"matchedTerm_active__2QfbU"};